var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SoundQuestion',{attrs:{"role":_vm.role,"ask-question":"Luister goed naar het Sinterklaas!","question":"Wat is het rijtuigtype van Sinterklaas' vervoersmiddel?","correct-answer":"Schimmel","wrong-answers":['Haflinger',
  'Bacterie',
  'Audi'
  ,'Ford'
  ,'Mustang'],"ask-question-audio":require('@/assets/audio/vraag_7_vraag.mp3'),"answer-audio":require('@/assets/audio/vraag_7_antwoord.mp3'),"show-answer-after":3000}})}
var staticRenderFns = []

export { render, staticRenderFns }